// extracted by mini-css-extract-plugin
export default {"processingContent":"modal-processing-payment_processingContent__fe7jP"};